module.exports = __webpack_public_path__ + "img/demand.82dde0f9.svg";